/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFileTypeZip = createReactComponent("file-type-zip", "IconFileTypeZip", [
  ["path", { d: "M14 3v4a1 1 0 0 0 1 1h4", key: "svg-0" }],
  ["path", { d: "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", key: "svg-1" }],
  ["path", { d: "M16 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6", key: "svg-2" }],
  ["path", { d: "M12 15v6", key: "svg-3" }],
  ["path", { d: "M5 15h3l-3 6h3", key: "svg-4" }]
]);

export { IconFileTypeZip as default };
//# sourceMappingURL=IconFileTypeZip.js.map
